import { render, staticRenderFns } from "./simple-keyboard.vue?vue&type=template&id=5db2f144&scoped=true&"
import script from "./simple-keyboard.vue?vue&type=script&lang=js&"
export * from "./simple-keyboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db2f144",
  null
  
)

export default component.exports